export default "__VITE_ASSET__CQxPFQxU__"